// extracted by mini-css-extract-plugin
export default {"Button_0":"BooleanValueSelect-module__Button_0__HKc6HrE","Octicon_0":"BooleanValueSelect-module__Octicon_0__CMLAyQL"};